import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';

const Head = () => {
  const { t } = useTranslation('live-account');
  return (
    <Flex className={styles['head__container']}>
      <TextBold className={styles['head__title']}>{t('pageTitle')}</TextBold>
    </Flex>
  );
};

export default Head;
